export const isValidEmail = (email: string): boolean => {
  return /\S+@\S+\.\S+/.test(email);
};

export const withPrefilledEmail = (href: string, email: string) => {
  if (!email || !isValidEmail(email)) return href;

  const url = new URL(href);
  url.searchParams.set("prefilled_email", email);
  return url.toString();
};
